export abstract class Errors {
    public static noSelectedOrganisation(): Error { return new Error('Could not determine the selected organisation'); }
    public static invalidForm(): Error { return new Error('Form is invalid'); }
    public static invalidLineItem(): Error { return new Error('Line item is invalid'); }
}